import { combineReducers } from "redux"

import { products } from "./productsReducers"
import { families } from "./familiesReducers"

export const articles = combineReducers({products, families})